














































import Vue from 'vue';
import { State } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Prism from '@/components/ui/Prism.vue';
import DocButton from '@/components/ui/buttons/DocButton.vue';
import LanguageSelector from '@/components/ui/LanguageSelector.vue';
import TransitionExpand from '@/components/ui/TransitionExpand.vue';
import CodeRailsHeader from '@/components/docs-main/code-rails-view/CodeExampleHeader.vue';
import CodeExampleSource from '@/components/docs-main/code-rails-view/CodeExampleSource.vue';
import { TutorialContentSourceExample, TutorialContentSourceSDK } from '@/templates/Tutorial';
import {
  CurlPreparedCodeExample,
  HttpApiPreparedCodeExample,
  keyofLangList,
  keyofSdkList,
  PreparedExamplesType,
} from '@/templates/CodeExamples';
import { TransformSdkName } from '@/heplers/stringHelpers';
import { SelectedLanguagesPack } from '@/store/types';
import GlobalBus from '@/plugins/GlobalBus';

@Component({
  components: {
    CodeExampleSource,
    TransitionExpand,
    CodeRailsHeader,
    Prism,
    DocButton,
    LanguageSelector,
  },
})
export default class CodeExampleBody extends Vue {
  @Prop({ default: false }) isMobile: boolean;
  @Prop() data: TutorialContentSourceSDK;
  @Prop() layoutHeight: string;
  @Prop() uniqId: string;
  @State('isMobileCodeRails') isMobileState: boolean;
  @State('selectedLanguagesPack') selectedLanguagesPack: SelectedLanguagesPack;
  @State('pageRendered') pageRendered: boolean;

  public sdkKind: any = {
    isOneLangEnv: false,
    isMediaSdk: false,
    isHttpApi: false,
  };

  public oneLangEnvs: any[] = ['voxengine', 'html', 'javascript'];
  public preparedExamples: PreparedExamplesType = {}; // Измененные examples, для более удобной работы с ними
  public activeSdk: keyofSdkList = '';
  public isLoadPreparedExamples = false;
  private isShowCurrentPrism = false;
  private currentLang: keyofLangList = '';
  private active = false;

  get titleSdkToKey(): string {
    return TransformSdkName.titleToKey(this.activeSdk);
  }

  get getCodeExampleId() {
    return 'code-example__' + this.uniqId;
  }

  get heightNumber(): number {
    if (!this.layoutHeight) return 0;

    const heightNumberPx = this.layoutHeight.indexOf('px');

    return +this.layoutHeight.slice(0, heightNumberPx);
  }

  @Watch('isMobileState')
  onChangeMobileState() {
    if (!this.isMobile) {
      this.isShowCurrentPrism = true;
    }
  }

  @Watch('active')
  onChangeActive() {
    if (this.isMobile) this.isShowCurrentPrism = this.active;
  }

  @Watch('pageRendered')
  onPageRenderedChanged() {
    if (!this.isLoadPreparedExamples) {
      this.isLoadPreparedExamples = true;
      this.prepareSdk();
    }
  }

  beforeDestroy() {
    this.$off('changeHeaderSdk');
  }

  mounted() {
    this.isLoadPreparedExamples = true;
    this.prepareSdk();
    this.bindListeners();
  }

  getCodeBash(language: CurlPreparedCodeExample): string {
    return language['script'].source.replace(
      'bash token.sh',
      `<a href='/docs/guides/managementapi/jwt' target='_blank'>bash token.sh</a>`
    );
  }

  transformLang(lang: string) {
    if (this.currentLang === 'c#') return lang === 'csharp';
    else return lang === this.currentLang.toLowerCase();
  }

  bindListeners() {
    if (!this.isMobile) this.isShowCurrentPrism = true;

    // Подписка для мобильных codeExamples
    GlobalBus.on('setActiveCodeExample', (id: string) => {
      //Scroll to open functionality, possibly important in future
      //this.isShowCurrentPrism = id === this.getCodeExampleId;

      if (this.isShowCurrentPrism) this.scrollToCurrentSdk(id);
    });
    this.$on('changeHeaderData', (data: any) => {
      this.activeSdk = data.activeSdk;
      this.currentLang = data.currentLang;
      this.scrollToCurrentSdk(`code-example__${data.uniqId}`);
    });
  }

  // Если много sdk, то вычисляем позицию активного и скроллим до него и еще 30px чтобы не было вкрай
  scrollToCurrentSdk(id: string) {
    if (!document.getElementById(id)) return;

    let elm: HTMLElement = document.getElementById(id).querySelector('.code__tab.active');

    if (!elm || !elm.offsetParent) return;

    elm.offsetParent.scrollTo(elm.offsetLeft - elm.offsetWidth - 30, 0);
  }

  showActivePrism(languageName: string) {
    return this.transformLang(languageName) && this.isShowCurrentPrism;
  }

  /**
   * Вычисляем высоту плашки кода для того чтобы был скролл.97 - высота верхней панельки и языков, 56px - высота bash-панели
   */
  public computeCodeHeight(isBash: string | undefined): string {
    if (isBash === 'curl') return this.heightNumber - 153 + 'px';
    else return this.heightNumber - 97 + 'px';
  }

  /**
   * Обрабатываем язык для Prism
   */
  public transformLanguage(lang: string): string {
    if (!lang) return 'javascript';

    lang = lang.toLowerCase();

    return ['objc', 'curl', 'nodejs', 'php', 'java', 'json'].includes(lang) ? 'javascript' : lang;
  }

  /**
   * Вычисляем, по какому пути создания объекта нам идти, которое зависит от data.env,
   * создаем и отдаем подготовленный объект preparedExamples для рендера верстки
   */
  private computePreparedSdk(): PreparedExamplesType {
    if (['http_api', 'cti api'].includes(this.data.env)) {
      this.sdkKind.isHttpApi = true;
      let curlReducer = (acc: HttpApiPreparedCodeExample, value: TutorialContentSourceExample) => {
        if (!value) return { ...acc };

        return {
          ...acc,
          ...this.computeHttpApi(acc, value),
        };
      };

      //@ts-expect-error: type mismatch
      return this.data.examples.reduce(curlReducer, {});
    }

    if (this.oneLangEnvs.includes(this.data.env)) {
      this.sdkKind.isOneLangEnv = true;
      return this.data.examples[0];
    }

    if (this.data.env === 'media') {
      this.sdkKind.isMediaSdk = true;

      let mediaReducer = (acc: any, value: any) => {
        return {
          ...acc,
          ...{ [TransformSdkName.keyToTitle(value.title)]: value.examples },
        };
      };

      return this.data.examples.reduce(mediaReducer, {});
    }
  }

  /**
   * Создаем preparedExamples для HTTPAPI. Если там попадается curl, то создаем специальный объект СurlPreparedCodeExample
   */
  private computeHttpApi(
    acc: HttpApiPreparedCodeExample,
    value: TutorialContentSourceExample
  ): HttpApiPreparedCodeExample {
    if (value.lang === 'curl') {
      if (acc[value.lang])
        //@ts-expect-error: type is missing properties
        return { [value.lang]: { ...acc[value.lang], ...{ [value.name]: value } } };
      //@ts-expect-error: Type is not assignable to type 'TutorialContentSourceExample | CurlPreparedCodeExample'.
      else return { [value.lang]: { [value.name]: value } };
    }
    //@ts-expect-error: Type is not assignable to type 'TutorialContentSourceExample | CurlPreparedCodeExample'.
    else return { [value.lang]: value };
  }

  /**
   * Главный метод. Берем данные, что пришли с сервера, и парсим их в удобный нам для рендера объект preparedExamples
   * В зависимости от данных объект может быть с разной структурой.
   * Для mediaSdk/Voxengine/HttpApi парсятся немного различные структуры, после чего готовый объект раскидываем по темплейту
   */
  private prepareSdk() {
    this.preparedExamples = this.computePreparedSdk();
    this.isLoadPreparedExamples = false;
  }
}
